import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackIcon } from "../icons.js";
/**
 * The way back from a detail page (design-spec §3 "Session detail" head; variant E `.ve-back`):
 * a left chevron and the place's name in ink-2, no underline, the ink darkening to ink-1 on hover
 * (`--back-link-ink`, set by `interactions.css`). Not an accent link: it names a place, it does
 * not act. An `<a>` with a real `href`, so a modified click opens a new tab; a plain click calls
 * `onNavigate` for the single-page app's own router.
 */
export function BackLink({ href, children, onNavigate }) {
    return (_jsxs("a", { href: href, "data-back-link": "", onClick: (event) => {
            if (onNavigate === undefined)
                return;
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
                return;
            event.preventDefault();
            onNavigate();
        }, style: {
            display: "inline-flex", alignItems: "center", gap: "var(--space-075)",
            color: "var(--back-link-ink, var(--ink-2))", textDecoration: "none",
            fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
            borderRadius: "var(--radius-focus)",
            transition: "color var(--dur-fast) var(--ease-out)",
        }, children: [_jsx(BackIcon, {}), children] }));
}
